module.exports = __webpack_public_path__ + "d23fd8f6fd3f861870b529f7d2b58c6d.woff";


//////////////////
// WEBPACK FOOTER
// ./client/assets/fonts/TiemposTextWeb-RegularItalic.woff
// module id = 1104
// module chunks = 0